module.exports = __webpack_public_path__ + "static/media/LOGO_RIDF_2019.f38f307d.svg";